import React from 'react';
import Container from 'react-bootstrap/Container';
import { t } from '../../../../i18n';
import { scribbleDiagonalZigzagImage } from '../../../assets';
import { haidImage } from '../assets';
import SectionHeader from '../section-header';
import './styles.scss';

const GiftCardQuote = () => {
  return (
    <section className="gift-card-quote">
      <Container>
        <SectionHeader className="gift-card-quote__header">
          {t('DIGITAL_COURSES.GIFT_CARD_OVERVIEW.WHAT_OTHERS_THINK')}
          <img src={scribbleDiagonalZigzagImage} alt="Zigzag" className="gift-card-quote__header-scribble" />
        </SectionHeader>
        <div className="gift-card-quote__box">
          <img src={scribbleDiagonalZigzagImage} alt="Zigzag" className="gift-card-quote__box-scribble" />
          <img src={haidImage} alt="Haid" className="gift-card-quote__picture" />
          <div className="gift-card-quote__texts">
            <q>{t('DIGITAL_COURSES.GIFT_CARD_OVERVIEW.QUOTE_TEXT')}</q>
            <cite>{t('DIGITAL_COURSES.GIFT_CARD_OVERVIEW.QUOTE_AUTHOR')}</cite>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default GiftCardQuote;
